__turbopack_context__.v({
  "className": "inter_fdb46f8a-module__wO1BIq__className",
});
